import React from "react";
import { FaTag, FaExchangeAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

const grassImage = "/images/Grass.jpg";

const SwapInboxCard = ({ request, user, onAccept, onDecline }) => {
  const isPoolCare =
    request.category === "poolcare" || request.category === "pool_care";

  const isCleaning = request.category === "cleaning";

  // Legacy mowing often has no category
  const isMowing = !isCleaning && !isPoolCare;

  const rawStatus = request.status;

  const normalisedStatus =
    rawStatus === "requested"
      ? "pending"
      : rawStatus === "pending"
      ? "pending"
      : rawStatus === "accepted"
      ? "accepted"
      : rawStatus === "paid"
      ? "completed"
      : rawStatus === "completed"
      ? "completed"
      : rawStatus === "declined"
      ? "declined"
      : "pending";

  const statusConfig = {
    pending: {
      title: "Incoming Swap Request",
      label: "Pending",
      bg: "#fff3cd",
      color: "#856404",
    },
    accepted: {
      title: "Accepted Swap",
      label: "Accepted",
      bg: "#d4edda",
      color: "#155724",
    },
    declined: {
      title: "Declined Swap",
      label: "Declined",
      bg: "#f8d7da",
      color: "#721c24",
    },
    completed: {
      title: "Completed Swap",
      label: "Completed",
      bg: "#d1ecf1",
      color: "#0c5460",
    },
  };

  const current = statusConfig[normalisedStatus];

  const canAccept =
    Number(request.receiverId) === Number(user?.id) &&
    normalisedStatus === "pending";

  const image =
    (isCleaning && request.targetImage) ||
    request.image ||
    grassImage;

  const swapCode =
    request.targetListingCode ||
    request.swapListingId ||
    request.id ||
    "—";

  const fromSuburb =
    isCleaning || isPoolCare ? request.targetFromSuburb : request.fromSuburb;

  const fromPostcode =
    isCleaning || isPoolCare ? request.targetFromPostcode : request.fromPostcode;

  const toSuburb =
    isCleaning || isPoolCare ? request.targetToSuburb : request.toSuburb;

  const toPostcode =
    isCleaning || isPoolCare ? request.targetToPostcode : request.toPostcode;

  const detailsLink = isCleaning
    ? `/cleaning/swaps/${request.offeredListingCode}`
    : isPoolCare
    ? `/poolcare/swaps/${request.offeredListingCode}`
    : `/swap/${request.requesterListingId}`;

  const detailsText =
    normalisedStatus === "completed"
      ? "View Completed Swap"
      : normalisedStatus === "accepted"
      ? "View Deal"
      : "View Details";

  return (
    <div
      style={{
        background: "#fff",
        opacity: normalisedStatus === "declined" ? 0.65 : 1,
        padding: "15px",
        borderRadius: "12px",
        border: "1px solid #e0e0e0",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        maxWidth: "350px",
        margin: "0 auto",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "8px",
          gap: "8px",
        }}
      >
        <h3 style={{ margin: 0 }}>{current.title}</h3>

        <div
          style={{
            display: "inline-flex",
            padding: "4px 10px",
            backgroundColor: current.bg,
            color: current.color,
            borderRadius: "20px",
            fontSize: "13px",
            alignItems: "center",
            gap: "5px",
            whiteSpace: "nowrap",
          }}
        >
          <FaExchangeAlt /> {current.label}
        </div>
      </div>

      {/* IMAGE */}
      <img
        src={image}
        alt="swap preview"
        style={{
          width: "100%",
          height: "160px",
          objectFit: "cover",
          borderRadius: "10px",
          marginBottom: "10px",
        }}
      />

      {/* SWAP ID */}
      <div style={{ marginBottom: "8px", fontSize: "14px", color: "#555" }}>
        <FaTag /> <strong>{swapCode}</strong>
      </div>

      {/* FROM / TO */}
      <div
        style={{
          background: "#f9f9f9",
          padding: "10px",
          borderRadius: "8px",
          border: "1px solid #eee",
          marginBottom: "10px",
          fontSize: "14px",
        }}
      >
        <strong>From:</strong> {fromSuburb || "—"} {fromPostcode || ""}
        <br />
        <strong>To:</strong> {toSuburb || "—"} {toPostcode || ""}
      </div>

      {/* CLEANING */}
      {isCleaning && (
        <div style={{ marginBottom: "10px" }}>
          <div
            style={{
              background: "#f5f5f5",
              padding: "10px",
              borderRadius: "8px",
              border: "1px solid #ddd",
              marginBottom: "6px",
              fontSize: "14px",
            }}
          >
            <strong>My listing (being requested):</strong>
            <br />
            {request.targetFromSuburb || "—"} → {request.targetToSuburb || "—"}
            <br />
            <small style={{ color: "#555" }}>
              Listing ID: {request.targetListingCode}
            </small>
          </div>

          <div
            style={{
              background: "#e8f5e9",
              padding: "10px",
              borderRadius: "8px",
              border: "1px solid #c8e6c9",
              fontSize: "14px",
            }}
          >
            <strong>They are offering:</strong>
            <br />
            {request.offeredFromSuburb || "—"} → {request.offeredToSuburb || "—"}
            <br />
            <small style={{ color: "#2e7d32" }}>
              Listing ID: {request.offeredListingCode}
            </small>
          </div>
        </div>
      )}

      {/* POOL CARE */}
      {isPoolCare && (
        <div style={{ marginBottom: "10px" }}>
          <div
            style={{
              background: "#f5f5f5",
              padding: "10px",
              borderRadius: "8px",
              border: "1px solid #ddd",
              marginBottom: "6px",
              fontSize: "14px",
            }}
          >
            <strong>My listing (being requested):</strong>
            <br />
            {request.targetFromSuburb || "—"} → {request.targetToSuburb || "—"}
            <br />
            <small style={{ color: "#555" }}>
              Listing ID: {request.targetListingCode}
            </small>
          </div>

          <div
            style={{
              background: "#e8f5e9",
              padding: "10px",
              borderRadius: "8px",
              border: "1px solid #c8e6c9",
              fontSize: "14px",
            }}
          >
            <strong>They are offering:</strong>
            <br />
            {request.offeredFromSuburb || "—"} → {request.offeredToSuburb || "—"}
            <br />
            <small style={{ color: "#2e7d32" }}>
              Listing ID: {request.offeredListingCode}
            </small>
          </div>
        </div>
      )}

      {/* MOWING */}
      {isMowing && (
        <div style={{ marginBottom: "10px" }}>
          <div
            style={{
              background: "#f5f5f5",
              padding: "10px",
              borderRadius: "8px",
              border: "1px solid #ddd",
              marginBottom: "6px",
              fontSize: "14px",
            }}
          >
            <strong>My listing (being requested):</strong>
            <br />
            {request.fromSuburb || "—"} → {request.toSuburb || "—"}
            <br />
            <small style={{ color: "#555" }}>
              Listing ID: {request.targetListingCode}
            </small>
          </div>

          <div
            style={{
              background: "#e8f5e9",
              padding: "10px",
              borderRadius: "8px",
              border: "1px solid #c8e6c9",
              fontSize: "14px",
            }}
          >
            <strong>They are offering:</strong>
            <br />
            {request.fromSuburb || "—"} → {request.toSuburb || "—"}
            <br />
            <small style={{ color: "#2e7d32" }}>
              Listing ID: {request.offeredListingCode}
            </small>
          </div>
        </div>
      )}

      {/* STATUS */}
      <div
        style={{
          marginTop: "12px",
          fontSize: "14px",
          fontWeight: "bold",
          color: current.color,
        }}
      >
        Status: {current.label}
      </div>

      {/* VIEW DETAILS */}
      <div style={{ marginTop: "12px" }}>
        <Link to={detailsLink} state={{ fromInbox: true }}>
          {detailsText}
        </Link>
      </div>

      {/* ACCEPT / DECLINE */}
      {canAccept && (
        <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
          <button
            style={{
              flex: 1,
              padding: "10px",
              borderRadius: "8px",
              border: "none",
              fontSize: "14px",
              cursor: "pointer",
              backgroundColor: "#43a047",
              color: "#fff",
            }}
            onClick={() => onAccept(request)}
          >
            Accept
          </button>

          <button
            style={{
              flex: 1,
              padding: "10px",
              borderRadius: "8px",
              border: "none",
              fontSize: "14px",
              cursor: "pointer",
              backgroundColor: "#e53935",
              color: "#fff",
            }}
            onClick={() => onDecline(request)}
          >
            Decline
          </button>
        </div>
      )}
    </div>
  );
};

export default SwapInboxCard;